import {
  getApiUrl,
  getResource,
  fetchWithRetry
} from "./APIOperations";
import toast from "react-hot-toast";

export const getProject = async (id) => {
  try {
    const data = await getResource(`/api/project/${id}`);
    return data;
  } catch (error) {
    console.error(`Error: ${error.message}`);
    return null;
  }
};

export const getProjectInfo = (file, enqueueSnackbar, resultHandler) => {
  let getAPI =
    "/api/projects/" +
    file.folderName +
    "/file/" +
    file.name +
    "/owner/" +
    file.ownerName;
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }

  fetch(getAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    redirect: "manual",
  })
    .then((response) => {
      if (response.type === "opaqueredirect") {
        enqueueSnackbar(
          "Failed to fetch. Hence the page will be automatically refreshed, and signin again.",
          { variant: "error" }
        );
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
        return;
      }
      if (!response.ok) {
        response
          .text()
          .then((text) => {
            throw Error(response.statusText + ": " + text);
          })
          .catch((error) =>
            this.props.enqueueSnackbar(error.message, { variant: "error" })
          );
      } else {
        response.json().then((result) => {
          resultHandler(result);
        });
      }
    })
    .catch((error) =>
      this.props.enqueueSnackbar(error.message + { variant: "error" })
    );
};

export const getUnqId = (resultHandler) => {
  let getUnqIdAPI = "/api/projects/getUnqID";
  if (process.env.NODE_ENV !== "production") {
    getUnqIdAPI = "http://localhost:7071" + getUnqIdAPI;
  }
  fetch(getUnqIdAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      response.json().then((result) => {
        resultHandler(result.id);
      });
    }
  });
};

export const saveEvaProject = (project, resultHandler) => {
  const saveState = project.toJS();
  let saveAPI = "/api/projects/saveEVAfile";
  if (process.env.NODE_ENV !== "production") {
    saveAPI = "http://localhost:7071" + saveAPI;
  }
  fetch(saveAPI, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Id: project.id,
      Name: project.name,
      FolderName: project.folderName,
      ProjectData: JSON.stringify(saveState),
    }),
  }).then((response) => {
    if (!response.ok) {
      response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      response.json().then((result) => resultHandler(result));
    }
  });
};

export const checkHash = (projectId, hashCode, enqueueSnackbar) => {
  let checkHashAPI =
    "/api/projects/" + projectId + "/" + hashCode + "/checkHash";
  if (process.env.NODE_ENV !== "production") {
    checkHashAPI = "http://localhost:7071" + checkHashAPI;
  }
  return fetch(checkHashAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    redirect: "manual",
  }).then((response) => {
    if (response.type === "opaqueredirect") {
      window.location.href = "/login";
      throw Error("Failed to fetch. Hence the page will be automatically refreshed, and signin again.",
        {cause: response.type});
    }
    if (!response.ok) {
      response
        .text()
        .then((text) => {
          throw Error(response.statusText + ": " + text);
        })
        .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
    }
  });
};

export const refreshProject = (project, resultHandler) => {
  const saveState = project.toJS();
  let saveAPI = "/api/refreshProject";
  if (process.env.NODE_ENV !== "production") {
    saveAPI = "http://localhost:7071" + saveAPI;
  }
  fetch(saveAPI, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(saveState),
  }).then((response) => {
    if (!response.ok) {
      response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      response.json().then((result) => resultHandler(result));
    }
  });
};

export const rebaselineProject = (
  project,
  period,
  baselineDescription,
  resultHandler
) => {
  const saveState = project.toJS();
  baselineDescription =
    baselineDescription === null ||
    baselineDescription === undefined ||
    baselineDescription === "" ||
    baselineDescription === " "
      ? "<empty>"
      : baselineDescription;
  let saveAPI =
    "/api/projects/rebaseline/" + period + "/" + baselineDescription;
  if (process.env.NODE_ENV !== "production") {
    saveAPI = "http://localhost:7071" + saveAPI;
  }
  fetch(saveAPI, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(saveState),
  }).then((response) => {
    if (!response.ok) {
      response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      response.json().then((result) => resultHandler(result));
    }
  });
};

export const projectPrebaselines = (
  project,
  loadedPrebaseline,
  resultHandler
) => {
  const saveState = project.toJS();
  if (project.id === 'none') {
    resultHandler({});
    return;
  }
  let saveAPI = "/api/project/" + project.id +  "/prebaselines";
  if (process.env.NODE_ENV !== "production") {
    saveAPI = "http://localhost:7071" + saveAPI;
  }
  loadedPrebaseline(true);
  fetch(saveAPI, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(saveState),
  }).then((response) => {
    if (!response.ok) {
      response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      response.json().then((result) => {
        resultHandler(result);
        loadedPrebaseline(false);
      });
    }
  });
};

export const getBaselineData = (
  project,
  taskId,
  baselineNumber,
  loadedPrebaselineTask,
  enqueueSnackbar,
  resultHandler
) => {
  const saveState = project.toJS();
  let getAPI =
    "/api/projects/tasks/" + taskId + "/baselineData/" + baselineNumber;
  if (process.env.NODE_ENV !== "production") {
    getAPI = "http://localhost:7071" + getAPI;
  }
  loadedPrebaselineTask(true);
  fetch(getAPI, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(saveState),
  }).then((response) => {
    if (!response.ok) {
      response
      .text()
      .then((text) => {
        throw Error(response.statusText + ": " + text);
      })
      .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
    } else {
      response.json().then((result) => {
        resultHandler(result);
        loadedPrebaselineTask(false);
      });
    }
  });
};

export const editBaselineData = (
  project,
  task,
  baselineNumber,
  saving,
  enqueueSnackbar,
  resultHandler
  ) => {
  let editAPI =
    "/api/projects/" + project.id + "/" + project.currentHash + "/editBaselineData/" + baselineNumber;
  if (process.env.NODE_ENV !== "production") {
    editAPI = "http://localhost:7071" + editAPI;
  }
  saving(true);
  fetch(editAPI, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(task.toJS()),
  }).then((response) => {
    if (!response.ok) {
      response
      .text()
      .then((text) => {
        throw Error(response.statusText + ": " + text);
      })
      .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
    } else {
      response.json().then((result) => {
        resultHandler(result)
        saving(false);
      });
    }
  });
};

export const startProjectDownload = (projectId, resultHandler) => {
  let downloadAPI = "/api/analysis/" + projectId + "/flat";
  if (process.env.NODE_ENV !== "production") {
    downloadAPI = "http://localhost:7071" + downloadAPI;
  }
  return fetch(downloadAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      return response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      return response.json().then((result) => {
        resultHandler(result);
      });
    }
  });
};

export const getDownloadStatus = (instanceId, resultHandler) => {
  let statusAPI = "/api/orchestrator/" + instanceId;
  if (process.env.NODE_ENV !== "production") {
    statusAPI = "http://localhost:7071" + statusAPI;
  }
  return fetch(statusAPI, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      return response.text().then((text) => {
        throw Error(response.statusText + ": " + text);
      });
    } else {
      return response.json().then((result) => {
        resultHandler(result);
      });
    }
  });
};
